import React, { useEffect } from "react";
import "./PageBanner.css";
import pageBanner from "./assets/page-banner.jpg";

const PageBanner = () => {
  useEffect(() => {
    // Trigger animations on mount
    const banner = document.querySelector(".banner");
    const text = document.querySelector(".banner-text");
    banner.classList.add("slide-in");
    text.classList.add("slide-in-text");
  }, []);

  return (
    <div className="banner-wrapper">
      <div className="banner" style={{ backgroundImage: `url(${pageBanner})` }}>
        <div className="banner-text">Auction</div>
        <div className="banner-paragraph">JAPANESE USED CAR FOR SALE</div>
      </div>
    </div>
  );
};

export default PageBanner;